import { IApplicationState } from '../../../types/types';

export function isRouterHelp (
    state: IApplicationState
): boolean {
    const { args } = state.router;

    return args && args.includes('help');
}
